import React, { createContext, ReactNode, useContext, useMemo } from 'react';

import { useApiView } from '@futrli/views/hooks/useApiView';
import { getModifyUserInitialValues } from '@futrli/views/processors/users/userForm';
import { ProcessedUserRow } from '@futrli/views/processors/users/usersList';
import { UsersView } from '@futrli/views/views/users/UsersView/UsersView';

import { useUserForm } from '../../user-form/hooks/use-user-form';

interface ModifyUserContextProps {
  children?: ReactNode;
  user: ProcessedUserRow;
  workspaceId: string;
}

interface ModifyUserContextValues {
  form: ReturnType<typeof useUserForm>;
  user: ProcessedUserRow;
  view: ReturnType<typeof useApiView<UsersView>>;
}

const defaultState = ({} as unknown) as ModifyUserContextValues;

export const ModifyUserContext = createContext(defaultState);

export const ModifyUserContextProvider = ({ children, user, workspaceId }: ModifyUserContextProps) => {
  const view = useApiView(useMemo(() => new UsersView(workspaceId), [workspaceId]));
  const initialValues = useMemo(() => getModifyUserInitialValues(user), [user]);
  const form = useUserForm({
    initialValues,
    organisations: view.state.eligibleOrganisations,
    roles: view.state.roles
  });

  const values: ModifyUserContextValues = {
    form,
    user,
    view
  };

  return <ModifyUserContext.Provider value={values}>{children}</ModifyUserContext.Provider>;
};

export const useModifyUserContext = () => useContext(ModifyUserContext);
